import React from 'react';
import {withStyles} from 'material-ui/styles/index';
import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  DialogContainer,
  Heading,
} from '@adobe/react-spectrum';
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import styles from './styles';
import {getDateFormat} from '../../../common/utils';

class MetricsBarGraphModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen || this.props.isOpen !== this.state.isOpen) {
      this.setState({isOpen: this.props.isOpen});
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({isOpen});
    if (!isOpen) {
      const {onClose} = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  formatAxisDate = (dateStr) => {
    const {activeLanguage} = this.props;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;

    const dateFormat = getDateFormat(activeLanguage || 'en-GB');
    const separator = dateFormat.includes('.') ? '.' : '/';
    const tokens = dateFormat.split(/[/.]/);
    const values = {
      DD: parts[2],
      MM: parts[1],
      YYYY: parts[0],
    };

    return tokens.map(token => values[token] || token).join(separator);
  };

  buildChartData() {
    const {datasets} = this.props;
    if (!datasets || datasets.length === 0) return [];

    const allDates = [...new Set(datasets.flatMap(ds => ds.data.map(p => p.date)))].sort();

    return allDates.map(date => {
      const entry = {date};
      datasets.forEach(ds => {
        const point = ds.data.find(p => p.date === date);
        entry[ds.label] = point ? point.value : 0;
      });
      return entry;
    });
  }

  renderTooltipContent = ({active, payload, label}) => {
    if (!active || !payload || !payload.length) return null;
    const {classes, translate} = this.props;
    const total = payload.reduce((sum, entry) => sum + (entry.value || 0), 0);
    return (
      <div className={classes.tooltip}>
        <p className={classes.tooltipLabel}>{this.formatAxisDate(label)}</p>
        {payload.map(entry => (
          <p key={entry.name} className={classes.tooltipEntry} style={{color: entry.fill}}>{entry.name}: {entry.value}</p>
        ))}
        <p className={classes.tooltipTotal}>{translate('metrics_chart_total')}: {total}</p>
      </div>
    );
  };

  render() {
    const {classes, title, datasets, translate} = this.props;
    const {isOpen} = this.state;
    const chartData = this.buildChartData();
    const barDatasets = datasets ? datasets.filter(ds => !ds.isTotal) : [];

    return (
      <DialogContainer isDismissable={false} onDismiss={() => this.onOpenChange(false)}>
        {isOpen && (
          <Dialog>
            <Heading>{title}</Heading>
            <Content>
              <div className={classes.chartContainer}>
                <ResponsiveContainer width="100%" height={350}>
                  <ComposedChart data={chartData} margin={{top: 10, right: 30, left: 0, bottom: 5}}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tickFormatter={this.formatAxisDate} />
                    <YAxis />
                    <Tooltip content={this.renderTooltipContent} />
                    <Legend />
                    {barDatasets.map(ds => (
                      <Bar key={ds.label} dataKey={ds.label} stackId="a" fill={ds.color} />
                    ))}
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </Content>
            <ButtonGroup>
              <Button variant="secondary" onPress={() => this.onOpenChange(false)}>{translate('general_close')}</Button>
            </ButtonGroup>
          </Dialog>
        )}
      </DialogContainer>
    );
  }
}

export default withStyles(styles)(MetricsBarGraphModal);
